import { render, staticRenderFns } from "./AccessDeniedCard.vue?vue&type=template&id=55bfce30&scoped=true"
import script from "./AccessDeniedCard.vue?vue&type=script&lang=js"
export * from "./AccessDeniedCard.vue?vue&type=script&lang=js"
import style0 from "./AccessDeniedCard.vue?vue&type=style&index=0&id=55bfce30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bfce30",
  null
  
)

export default component.exports